import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../rtk-query-axios.service";
import { APP_BASE_URL_ALARM, APP_BASE_URL_NOTIFICATIONS, DISTINCT_STATIC_TYPE, NOTIFICATION_USER_MEDIUM } from "../../../Common/EndPoints";

type NotificationConfigurationQueryParams = {
    limit: number;
    offset: number;
    user_ids?: string;
    customer_ids?: string;
    search_text?: string;
    role_ids?: string
}

type NotificationMediumEntity = {
    userid: string;
    email: string;
    first_name: string;
    last_name: string;
    roleid: string;
    mobileno: string;
    role_name: string;
    notification_medium?: {
        type: string;
        enabled: boolean;
        id: string;
    }[];
}

type NotificationConfigurationResponse = {
    totalRecords: number;
    offset: number;
    limit: number;
    items: NotificationMediumEntity[];
}

type NotificationConfigurationMutationBody = {
    body: {
        mediums: string[],
        user_id: string
    }
}

type NotificationConfigurationPatchBody = {
    body: {
        enable: boolean,
        id: string,
        mode: string,
        user_id: string
    }
}

export const notificationConfigurationApi = createApi({
    reducerPath: "notificationConfigurationAPI",
    baseQuery: axiosBaseQuery,
    tagTypes: ["notification-configuration"],
    endpoints: (builder) => ({
        getAllNotificationMode: builder.query<any, {}>({
            query: () => ({
                url: APP_BASE_URL_ALARM + DISTINCT_STATIC_TYPE,
                method: "GET",
                params: {
                    type: "notification_mode",
                    db_enum: true,
                },
            }),
            transformResponse: (_response: any): any => _response,
        }),
        getNotificationConfiguration: builder.query<NotificationConfigurationResponse, NotificationConfigurationQueryParams>({
            query: (params) => ({
                url: APP_BASE_URL_NOTIFICATIONS + NOTIFICATION_USER_MEDIUM,
                method: "GET",
                params,
            }),
            providesTags: ["notification-configuration"],
            transformResponse: (_response: NotificationConfigurationResponse): NotificationConfigurationResponse => _response,
        }),
        postNotificationConfiguration: builder.mutation<any, NotificationConfigurationMutationBody>({
            query: ({ body }: NotificationConfigurationMutationBody) => {
                return {
                    url: APP_BASE_URL_NOTIFICATIONS + NOTIFICATION_USER_MEDIUM,
                    method: "POST",
                    data: {
                        mediums: body.mediums,
                        user_id: body.user_id,
                    },
                };
            },
            invalidatesTags: ["notification-configuration"],
        }),
        patchNotificationConfiguration: builder.mutation<any, NotificationConfigurationPatchBody>({
            query: ({ body }: NotificationConfigurationPatchBody) => {
                return {
                    url: APP_BASE_URL_NOTIFICATIONS + NOTIFICATION_USER_MEDIUM,
                    method: "PATCH",
                    data: {
                        enable: body.enable,
                        id: body.id,
                        mode: body.mode,
                        user_id: body.user_id,
                    },
                };
            },
            invalidatesTags: ["notification-configuration"],
        }),
    }),
});
